import { FormBase } from 'core/components';

export default class PumpStatusChangeForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'pumpStatusId',
                    label: 'PUMPS.EDIT.STATUS_LABEL',
                    placeholder: 'PUMPS.EDIT.STATUS_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'dateReturnRequested',
                    label: 'PUMPS.EDIT.DATE_RETURN_REQUESTED_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_RETURN_REQUESTED_PLACEHOLDER'
                },
                {
                    name: 'dateReturned',
                    label: 'PUMPS.EDIT.DATE_RETURNED_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_RETURNED_PLACEHOLDER'
                },
                {
                    name: 'dateSent',
                    label: 'PUMPS.EDIT.DATE_SENT_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_SENT_PLACEHOLDER'
                }
            ],
        };
    }
}
